import React from 'react'
import PropTypes from 'prop-types'

// Styled Elements
import {
  SubHeaderWrapper,
  SubHeaderNavList,
  SubHeaderNavListItem,
  SubHeaderNavListLink,
} from './TravelRuleTableItemSubHeader.elements'

function TravelRuleTableItemSubHeader(props) {
  // Hooks
  const { page, setPage } = props

  return (
    <SubHeaderWrapper>
      <SubHeaderNavList>
        <SubHeaderNavListItem>
          <SubHeaderNavListLink
            className={page === 0 && 'active'}
            onClick={() => {
              setPage(0)
            }}
          >
            Transfer flow
          </SubHeaderNavListLink>
        </SubHeaderNavListItem>

        <SubHeaderNavListItem>
          <SubHeaderNavListLink
            className={page === 1 && 'active'}
            onClick={() => {
              setPage(1)
            }}
          >
            Transfer details
          </SubHeaderNavListLink>
        </SubHeaderNavListItem>
      </SubHeaderNavList>
    </SubHeaderWrapper>
  )
}

// Default Props
TravelRuleTableItemSubHeader.defaultProps = {
  page: 0,
  setPage: () => {},
}

// Proptypes Validation
TravelRuleTableItemSubHeader.propTypes = {
  page: PropTypes.number,
  setPage: PropTypes.func,
}
export default TravelRuleTableItemSubHeader
